import React from 'react';
import { Session } from '@app/api';
import { Variants } from './Variants/Variants';
import { useTrackingParams } from '@app/analytics';
import { StudyDescriptionOriginal } from './Variants/Original';

interface Props {
  session: Session;
  sessionLinkId?: string;
  participationId?: string | undefined;
  onClick: () => any;
  buttonIsLoading?: boolean;
  buttonIsDisabled?: boolean;
  participantId?: string;
}

export const StudyDescription = (props: Props) => {
  const params = useTrackingParams();

  if (
    params.variant &&
    typeof params.variant === 'string' &&
    Variants[params.variant]
  ) {
    const Component = Variants[params.variant];
    return <Component {...props} />;
  }

  return <StudyDescriptionOriginal {...props} />;
};
